module.exports = __webpack_public_path__ + "img/join-03.46bc4736.jpg";